export default "__VITE_ASSET__4f2be160__"